import React, {useEffect, useState} from 'react';
import {Button, Card, Col, Container, Image, Row} from 'react-bootstrap';
import {useNavigate} from 'react-router-dom';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAngleRight, faCheck, faDatabase, faFileInvoiceDollar, faFileLines} from "@fortawesome/free-solid-svg-icons"; // 自定义样式文件
import './RechargePage.css';
import ApiService from "../../api/ApiService";
import LocalDataService from "../../api/LocalDataService";
import PayModal from "../../components/PayModal";
import {toast} from "react-toastify";


const wechatIcon = '/images/vip/vip_pay_method_wechat.svg'
const alipayIcon = '/images/vip/vip_pay_method_alipay.svg'

const RechargePage = () => {
    const navigate = useNavigate();
    const [selectedAmount, setSelectedAmount] = React.useState(null);
    const [selectedPaymentMethod, setSelectedPaymentMethod] = React.useState('wechat');
    const [payModalVisible, setPayModalVisible] = React.useState(false);

    const [user, setUser] = useState(null);
    const api = new ApiService();
    const [productList, setProductList] = React.useState([]);

    const handleRecharge = () => {
        // console.log(`Recharging with amount: ${amount}`);
        // 这里可以添加实际的充值逻辑
        setPayModalVisible(true)
    };

    function selectRechargeMoney(number) {
        setSelectedAmount(number);
    }

    useEffect(() => {
        const userData = LocalDataService.load_user_data();
        if (!userData) {
            toast.error('请先登录');
            return navigate("/home");
        }
        setUser(userData);
        getProductList();

        // 添加事件监听器
        const handleUserLoginStatusChange = () => {
            const userData = LocalDataService.load_user_data();
            setUser(userData);
        };
        window.addEventListener('userLoginStatusChanged', handleUserLoginStatusChange);

        return () => {
            window.removeEventListener('userLoginStatusChanged', handleUserLoginStatusChange);
        };
    }, []);

    async function getProductList() {
        var result = await api.productList('3');
        setProductList(result.data);
        setSelectedAmount(result.data[0])
    }

    return (
        <Container>
                <Card className="mb-4" style={{background: '#1D2126'}}>
                    <Card.Body>
                        <Row>
                        <Col lg={3} className="balance-divider">
                            <div style={{padding:"8px 28px"}} className="balance-section">
                                <h6 className={'balance-title'}><span className="account-balance-icon">
                                <FontAwesomeIcon icon={faDatabase} color={'#02C8E3'} width={'16px'} height={'16px'}/>
                            </span> 账户余额</h6>
                                <div className="balance">
                                    <span style={{fontSize: '22px'}}>¥</span>
                                    <span
                                        style={{fontSize: '32px'}}> {((user?.points?.perpetual + user?.points?.temp) / 100).toFixed(2)}</span>
                                </div>

                                <small style={{
                                    color: '#B4BFC5',
                                    fontSize: '12px',
                                }}>用于沸推插件的调用以及网页直接使用智能体单次费用</small>
                            </div>
                        </Col>
                        <Col lg={9}>
                            <div style={{textAlign: 'left',padding:'8px 28px'}} className="recharge-section">
                                <h6 style={{color: '#fff',marginBottom: '16px'}}>账户充值</h6>
                                <div className="recharge-options">
                                    {productList.map((item) => (
                                        <div style={{position: 'relative'}}>
                                            <Button
                                                className={`amount-button ${selectedAmount.id === item.id ? 'selected-amount-button' : 'default-amount-button'}`}
                                                onClick={() => selectRechargeMoney(item)}>{item.title}
                                                <div style={{fontSize: '12px'}}>
                                                    售价：¥{item.price / 100.0}
                                                </div>
                                            </Button>
                                            {item.config.badgeUrl &&
                                                <Image src={item.config.badgeUrl} width={38} height={38}
                                                       style={{position: 'absolute', left: '0px'}}/>}

                                        </div>

                                    ))}
                                </div>

                                <h6 style={{color: '#fff',marginBottom: '16px'}}>支付方式</h6>
                                <Row className="paymentMethod">
                                    <Col md={6}>
                                        <Button
                                            className={`w-100 mb-2 payment-method-button ${selectedPaymentMethod === 'wechat' ? 'selected-payment-method-button' : ''}`}
                                            onClick={() => setSelectedPaymentMethod('wechat')}>
                                            <img src={wechatIcon} alt="微信支付" className="payment-method-icon"/>
                                            微信支付
                                            <div className="payment-method-check">
                                                {selectedPaymentMethod === 'wechat' &&
                                                    <FontAwesomeIcon icon={faCheck} color={'#02C8E3'}/>}
                                            </div>
                                        </Button>
                                    </Col>
                                    <Col md={6}>
                                        <Button
                                            className={`w-100 mb-2 payment-method-button ${selectedPaymentMethod === 'alipay' ? 'selected-payment-method-button' : ''}`}
                                            onClick={() => setSelectedPaymentMethod('alipay')}>
                                            <img src={alipayIcon} alt="支付宝支付" className="payment-method-icon"/>
                                            支付宝支付
                                            <div className="payment-method-check">
                                                {selectedPaymentMethod === 'alipay' &&
                                                    <FontAwesomeIcon icon={faCheck} color={'#02C8E3'}/>}
                                            </div>
                                        </Button>
                                    </Col>

                                </Row>
                                <Button className="recharge-button" onClick={() => handleRecharge()}>立即充值</Button>
                            </div>
                        </Col>
                        </Row>
                    </Card.Body>
                </Card>
            <Row>
                <Col lg={4} md={6}>
                    <Card className="mb-4 recharge-feature-card" onClick={() => navigate('/ConsumptionRecordList')}>
                        <Card.Body className="card-body-container">
                            <div className="feature-icon-container">
                                <FontAwesomeIcon icon={faFileLines} color={'#02C8E3'} size={'2x'}/>
                            </div>
                            <div className="feature-text-container">
                                <h6 className="feature-title">消费明细</h6>
                                <p className="feature-description">查看您的充值和消费记录</p>
                            </div>
                            <FontAwesomeIcon icon={faAngleRight} className="right-arrow-icon"/>

                        </Card.Body>
                    </Card>
                </Col>

                <Col lg={4} md={6}>
                    <Card className="mb-4 recharge-feature-card" onClick={() => navigate('/ChargingStandardList')}>
                        <Card.Body className="card-body-container">
                            <div className="feature-icon-container">
                                <FontAwesomeIcon icon={faFileInvoiceDollar} color={'#02C8E3'} size={'2x'}/>
                            </div>
                            <div className="feature-text-container">
                                <h6 className="feature-title">计费标准</h6>
                                <p className="feature-description">了解各功能资源消耗规则</p>
                            </div>
                            <FontAwesomeIcon icon={faAngleRight} className="right-arrow-icon"/>
                        </Card.Body>
                    </Card>
                </Col>

            </Row>
            <PayModal visible={payModalVisible} product={selectedAmount} payMethod={selectedPaymentMethod}
                      onClose={() => setPayModalVisible(false)}></PayModal>
        </Container>
    );
};

export default RechargePage;